import './public-path';
import './utils/idsApiPathRewrite';
import { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.scss';
import { isDev, ThemeProvider, Themes, microAppRewrite } from '@maxtropy/components';
import { setupVersions } from '@maxtropy/strategy';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import localeData from 'dayjs/plugin/localeData';
dayjs.locale('zh-cn');
dayjs.extend(localeData);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(isToday);

microAppRewrite();

setupVersions();

const root = createRoot(document.getElementById('root') as Element);
const StrictModeComponent = isDev() ? Fragment : StrictMode;

root.render(
  <StrictModeComponent>
    <ThemeProvider theme={Themes.DARK}>
      <App />
    </ThemeProvider>
  </StrictModeComponent>
);
